import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode } from '@symphony-solo/shared/http/src';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {  AccountSettingsService } from '../services';
import { AlertService } from '@symphony-solo/shared/alert/src';
import {
  getNotificationsAction,
  getNotificationsErrorAction,
  getNotificationsSuccessAction,
  getSurvaysAction,
  getSurvaysErrorAction,
  getSurvaysSuccessAction,
  setNotificationsAction,
  setNotificationsErrorAction,
  setNotificationsSuccessAction,
  setSurvaysAction,
  setSurvaysErrorAction,
  setSurvaysSuccessAction,
} from './account-settings.actions';
import { AccountSettingsFacade } from './account-settings.facade';

@Injectable()
export class AccountSettingsEffects {
  constructor(
    private action$: Actions,
    private accountSettingsService: AccountSettingsService,
    private accountSettingsFacade: AccountSettingsFacade,
    private alertService: AlertService
  ) {}

  

  protected getSurvays$ = createEffect(() =>
    this.action$.pipe(
      ofType(getSurvaysAction),
      switchMap(() => {
        return this.accountSettingsService.getSurvays().pipe(
          map((survays: any) => getSurvaysSuccessAction({survays})),
          catchError(() => {
            const failure = new AppStateFailureBuilder()
              .setFailureType(FailureType.API)
              .addFailure(new AppStateFailureItemWithErrorCode('Error on getting survays', ApiResponseCode.Server_Error))
              .build();
            return of(getSurvaysErrorAction({ failure }));
          })
        );
      })
    )
  );

  protected setSurvays$ = createEffect(() =>
    this.action$.pipe(
      ofType(setSurvaysAction),
      switchMap((surveyQuestionAnswers) => {
        return this.accountSettingsService.setSurvayQuestionsAnswers(surveyQuestionAnswers).pipe(
          map(() => setSurvaysSuccessAction()),
          catchError(() => {
            const failure = new AppStateFailureBuilder()
              .setFailureType(FailureType.API)
              .addFailure(new AppStateFailureItemWithErrorCode('Error on setting survays', ApiResponseCode.Server_Error))
              .build();
            return of(setSurvaysErrorAction({ failure }));
          })
        );
      })
    )
  );
  protected setSurvaysSuccess$ = createEffect(() =>
  this.action$.pipe(
    ofType(setSurvaysSuccessAction),
    tap(() => {
      const okButton = {
        text: 'OK',
        cssClass: 'okButton centerButton',
      };
      this.alertService.presentAlert(
        'Success',
        'Thank you! your survey has been saved successfully.',
        [okButton]
      );
    })
  ),
{
  dispatch: false,
}
  );


  protected getNotifications$ = createEffect(() =>
  this.action$.pipe(
    ofType(getNotificationsAction),
    switchMap(() => {
      return this.accountSettingsService.getNotifications().pipe(
        map((notifications: any) => getNotificationsSuccessAction({notifications})),
        catchError(() => {
          const failure = new AppStateFailureBuilder()
            .setFailureType(FailureType.API)
            .addFailure(new AppStateFailureItemWithErrorCode('Error on getting Notifications', ApiResponseCode.Server_Error))
            .build();
          return of(getNotificationsErrorAction({ failure }));
        })
      );
    })
  )
);

protected setNotifications$ = createEffect(() =>
  this.action$.pipe(
    ofType(setNotificationsAction),
    switchMap((setNotifications) => {
      return this.accountSettingsService.setNotifications(setNotifications).pipe(
        tap(() => this.accountSettingsFacade.getNotifications()),
        map(() => setNotificationsSuccessAction()),
        catchError(() => {
          const failure = new AppStateFailureBuilder()
            .setFailureType(FailureType.API)
            .addFailure(new AppStateFailureItemWithErrorCode('Error on setting Notifications', ApiResponseCode.Server_Error))
            .build();
          return of(setNotificationsErrorAction({ failure }));
        })
      );
    })
  )
);
protected setNotificationsSuccess$ = createEffect(() =>
this.action$.pipe(
  ofType(setNotificationsSuccessAction),
  tap(() => {
    const okButton = {
      text: 'OK',
      cssClass: 'okButton centerButton',
    };
    this.alertService.presentAlert(
      'Success',
      'Thank you! your notification has been updated successfully.',
      [okButton]
    );
  })
),
{
dispatch: false,
}
);

  
}
